import BN from 'bignumber.js';

export function rewardValue(d) {
  if (!d) {
    return '-';
  }

  switch (d.reward_type) {
    case 'flat':
      return `$${new BN(d.reward).toFormat(2)}`;
    case 'percent':
      return `${new BN(d.reward).toString()}%`;
    case 'variable_percent':
      return `Up to ${new BN(d.reward).toString()}%`;
    case 'variable_flat':
      return `Up to $${new BN(d.reward).toFormat(2)}`;
    case 'percent_commission':
      return `${new BN(d.reward).toString()}% commission`;
    default:
      return `${d.reward} (${d.reward_type})`;
  }
}
